import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ItemConvertCatalogHeader() {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div className="member-diamonds-subheader row">
      <div className="col-xs-12">
        <div className="member-diamonds-subheader-menu">
          <span className="text-capitalize">{t('item_convert_title')}</span>
          <div className="member-diamonds-subheader-menu-items" />
        </div>
        <hr />
      </div>
    </div>
  );
}
